<template>
  <mime-types-list
    v-if="selectedDomain.id"
    :tier="tierType"
    :id="selectedDomain.id"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import MimeTypesList from "@/views/Common/AttachmentFilters/MimeType.vue";

import { TIER } from "@/constants";

export default {
  name: "MimeTypes",
  components: {
    MimeTypesList,
  },
  data() {
    return {
      tierType: TIER.domains,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedDomain"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  created() {
    this.setPageTitle(this.$t("Attachments"));
    this.setPageSubtitle([]);
  },
};
</script>
